'use client'

import { Box } from '@mui/joy'
import { useRef } from 'react'

interface FBPostProps {
	attr: {
		[name: string]: string
	}
}
const FBPost = ({ attr }: FBPostProps) => {
	const fbRef = useRef<HTMLDivElement>(null)

	return (
		<Box
			ref={fbRef}
			className={`fb-post ${attr.class}`}
			data-href={attr['data-href']}
			sx={{
				'&': {
					marginBottom: '0!important',
					maxWidth: '100%',
					'& > span': {
						maxWidth: '100%!important',
					},
					'& iframe': {
						marginBottom: '0!important',
					},
				},
			}}
		/>
	)
}

export default FBPost
